import { Tooth } from '@/shared/api/protocol-ts/model/dto_report_tooth_pb';

import { JAW, JawObject } from '../config';

import { getJawQuartile } from './getJawQuartile';

export const makeJawObject = (teeth: Partial<Tooth>[]): JawObject =>
  teeth.reduce<JawObject>(
    (acc, tooth) => {
      const quartile = getJawQuartile(tooth.Numeration?.ISO ?? 0);

      return {
        ...acc,
        [quartile]: teeth.filter(({ Numeration }) => {
          const ISONumber = Numeration?.ISO;

          // TODO type error?
          return JAW[quartile].includes(ISONumber ?? 0);
        }),
      };
    },
    {
      quartile1: [] as Tooth[],
      quartile2: [] as Tooth[],
      quartile3: [] as Tooth[],
      quartile4: [] as Tooth[],
    } as JawObject,
  );
